import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import AboutVideo from "@/components/AboutVideo";
import Bio from "@/components/Bio";
import Reel from "@/components/Reel";
import Acting from "@/components/Acting";
import Directing from "@/components/Directing";
import Gallery from "@/components/Gallery";
import CastingProfiles from "@/components/CastingProfiles";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Home() {
    return (
        <main data-testid="home-page" className="bg-[#F7F5F0] text-[#1A1A1A]">
            <Navbar />
            <Hero />
            <AboutVideo />
            <Bio />
            <Reel />
            <Acting />
            <Directing />
            <Gallery />
            <CastingProfiles />
            <Contact />
            <Footer />
        </main>
    );
}
